import { Nav } from "@/components/Nav";
import { Products } from "@/components/Products";
import { Footer } from "@/components/Footer";

export default function CollectionPage() {
  return (
    <main className="pt-16" data-testid="collection-page">
      <Nav />
      <Products />
      <Footer />
    </main>
  );
}
